<template>
  <ods-module class="user__module">
    <header class="user__header">
      <h1>{{$t('user.account.header')}}</h1>
      <ods-button class="cancelBtn" type="secondary" @click.native="resetForm('accountForm')">{{$t('user.account.inputs.cancel')}}</ods-button>
    </header>
    <!-- USER DATA SECTION -->
    <section class="user__data">
      <section class="user__form-container">
        <ods-form
          ref="accountForm"
          :rules="accountRules"
          class="user__form"
          :model="accountForm"
          >
          <ods-form-item
            :label="$t('user.account.inputs.user')"
            prop="currentUser" style="margin: 12px 0px 24px 0px">
              <ods-input
                v-model="currentUser"
                :disabled="true" />
          </ods-form-item>

          <div class="user__change-password">
            <h2 class="user__section-title">{{$t('user.account.title')}}</h2>

            <ods-form-item
              prop="newPassword"
              :label="$t('user.account.inputs.password')">
                  <ods-input
                    v-model="accountForm.newPassword"
                    :class="{ error: errors }"
                    type="password"
                    show-password
                    :autocomplete="$t('user.account.inputs.password')" />
              </ods-form-item>

              <ods-form-item
                prop="checkPassword"
                :label="$t('user.account.inputs.checkpassword')">
                  <ods-input
                    v-model="accountForm.checkPassword"
                    :class="{ error: errors }"
                    type="password"
                    show-password
                    :autocomplete="$t('user.account.inputs.checkpassword')" />
              </ods-form-item>
          </div>

          <ods-button
            :disabled="disableButton"
            @click.native="submitForm()"
            >{{$t('user.account.inputs.send')}}
          </ods-button>

        </ods-form>
      </section>
      <!-- INFORMATION SECTION -->
      <section class="user__info">
        <p>{{$t('user.account.info')}}</p>
      </section>
    </section>
      </ods-module>
</template>
<script>
import { mapActions } from 'vuex'
import { HTTP_PLATFORM } from '../../store/modules/http'
export default {
  name: 'Account',
  data () {
    // 10-128 CHARS, A-Z,a-z and at least 1 special char.
    var passwordPattern = new RegExp(/(?=^.{10,128}$)((?=.*\d)|(?=.*\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$/)

    // Password validation rule
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('' + this.$i18n.t('user.account.validations.newpassword.required')))
      } else {
        if (passwordPattern.test(value)) {
          if (this.accountForm.checkPassword !== '') {
            this.$refs.accountForm.validateField('checkPassword')
          }
        } else {
          callback(new Error('' + this.$i18n.t('user.account.validations.newpassword.pattern')))
        }
        callback()
      }
    }
    // Repeat Password validation rule
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('' + this.$i18n.t('user.account.validations.checkpassword.required')))
      } else if (value !== this.accountForm.newPassword) {
        callback(new Error('' + this.$i18n.t('user.account.validations.checkpassword.same')))
      } else {
        callback()
      }
    }
    return {
      $t: this.$i18n.t,
      // user Account
      currentUser: sessionStorage.username,
      accountForm: {
        newPassword: '',
        checkPassword: ''
      },
      // Validation Form Rules
      accountRules: {
        newPassword: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPassword: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      errors: false
    }
  },
  methods: {
    ...mapActions([
      'login'
    ]),
    // Change Password Submit
    submitForm () {
      this.$refs.accountForm.validate(async (valid) => {
        if (!valid) {
          this.errors = true
          return false
        }
        try {
          const changePassEndPoint = '/controlpanel/api/users/' + sessionStorage.username + '/change-password'
          const changePass = await HTTP_PLATFORM.post(changePassEndPoint, this.accountForm.newPassword, { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } })
          if (changePass) {
            this.$notify({
              title: '' + this.$i18n.t('user.account.notifications.success_title'),
              type: 'success',
              position: 'top-right',
              duration: 4000,
              onClose: this.successChangeClose(this.accountForm.newPassword)
            })
          }
        } catch (error) {
          this.$notify({
            title: '' + this.$i18n.t('user.account.notifications.error_title'),
            message: '' + this.$i18n.t('user.account.notifications.error_msg'),
            type: 'error',
            position: 'top-right',
            duration: 3000
          })
        } finally {
          this.accountForm.newPassword = ''
          this.accountForm.checkPassword = ''
        }
      })
    },
    async successChangeClose (newPass) {
      // MAKE A INTERNAL LOGIN TO UPDATE DE USER SESSION AUTH.-
      const data = {
        username: sessionStorage.username,
        password: newPass
      }
      try {
        // LOGIN, update API auth
        const response = await this.login(data)
        const isError = response instanceof Error

        if (!isError) {
          sessionStorage.sessionToken = response.data.access_token
          HTTP_PLATFORM.defaults.headers.common.Authorization = 'Bearer ' + response.data.access_token
          this.goBack()
        } else {
          // error in login again, go to login.
          setTimeout(function () { this.$router.push({ name: 'Login' }) }.bind(this), 3000)
        }
      } catch (error) {
        console.log(error)
        return false
      }
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.goBack()
    },
    goBack () {
      var previousRoute = sessionStorage.getItem('prevRoute') ? sessionStorage.getItem('prevRoute') : '/dashboard/' + sessionStorage.getItem('favorite')
      setTimeout(function () { this.$router.push({ path: previousRoute }) }.bind(this), 3000)
    }
  },
  computed: {
    isSamePassword () {
      return ((this.accountForm.newPassword === this.accountForm.checkPassword) && (this.accountForm.newPassword !== '') && (this.accountForm.checkPassword !== ''))
    },
    disableButton () {
      return !this.isSamePassword
    }
  }
}
</script>
<style lang="scss" scoped>
.user {
  &__module {
    border: 1px solid var(--color-border-soft-divisor);
  }

  &__header {
    @include txt-title-150;
    border-bottom: $border-size-200 solid var(--color-border-soft-divisor);
    padding: $space-300;
  }

  &__data {
    display: flex;
    height: calc(100vh - 175px);
  }

  &__form-container {
    width: 70%;
    padding: $space-300;
  }

  &__info {
    width: 30%;
    padding: rem(24);
    background: var(--color-bg-secondary);
  }

  &__form {
    max-width: rem(550);
  }
}

::v-deep .ods-module__body {
  padding: 0;
}

::v-deep .ods-form-item {
  margin-bottom: 2rem !important;
  margin-top: 2rem !important;
}

.user-account { display: block; }
.user__section-title {
  @include txt-title-150;
    border-bottom: $border-size-200 solid var(--color-border-soft-divisor);
    padding: $space-200;
}
.title {
    @include txt-title-300;
    margin-bottom: $space-200;
}
.cancelBtn {
  display: inline-block;
  float: right;
  position: absolute;
  right: 42px;
  top: 42px;
}
::v-deep .ods-alert { margin: 12px 0px 24px 0px; }
</style>
